import apiClient from '../helpers/apiClient';

class ProfileService {
    loadUserProfile = () => apiClient().post('view_profile');
    updateUserProfile = (data) => apiClient().post('update_profile?_method=PUT', data);
    createOrder = () => apiClient().post('razorpay');
    verifyPayment = (rzResponse) => apiClient().post('verify_payment', rzResponse);
}

export default new ProfileService();